import { FormApi } from 'final-form';
import { OnChange } from '@occc/ui-forms';
import { Offer_Presentation_Priority, Offer_Presentation_Type } from '@occc/graphql';

import { MarketingContentFormValuesPaths } from './types';

type PresentationTypeWatcherProps = {
  form: FormApi<any>;
};

export const PresentationTypeWatcher = ({ form }: PresentationTypeWatcherProps) => (
  <OnChange name={'offer.presentationType' satisfies MarketingContentFormValuesPaths}>
    {(presentationType: Offer_Presentation_Type) => {
      const presentationPriorityFieldName =
        'offer.presentationPriority' satisfies MarketingContentFormValuesPaths;
      const displayCategoriesFieldName =
        'displayCategories' satisfies MarketingContentFormValuesPaths;

      // Banners are inherently featured and cannot be categorized.
      if (presentationType === Offer_Presentation_Type.Banner) {
        form.change(presentationPriorityFieldName, Offer_Presentation_Priority.Featured);
        form.change(displayCategoriesFieldName, []);
        return;
      }

      // Hidden offers are not shown, so they are neither featured nor categorized.
      if (presentationType === Offer_Presentation_Type.Hidden) {
        form.change(presentationPriorityFieldName, Offer_Presentation_Priority.Default);
        form.change(displayCategoriesFieldName, []);
        return;
      }

      form.change(presentationPriorityFieldName, Offer_Presentation_Priority.Default);
    }}
  </OnChange>
);
